
function shopifyRoute(path) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const normalizedRoot = root.endsWith('/') ? root : root + '/';
  return normalizedRoot + path.replace(/^\//, '');
}

function clearSideCartParam() {
  const url = new URL(window.location.href);
  url.searchParams.delete('side-cart');
  window.history.replaceState({}, '', url.pathname + url.search + url.hash);
}

function tabSwiper() {
  if (typeof Swiper !== "undefined") {
    const allTabWrapEle = document.querySelectorAll(".tabbed-collection-slider");
    if(allTabWrapEle && allTabWrapEle.length > 0){
      allTabWrapEle.forEach(ele=>{
        const tabButtons = ele.querySelectorAll(`.tab-btn`);
        const tabContents = ele.querySelectorAll(`.tab-content`);
        const swipers = {};
        tabContents.forEach((tab, index) => {
          const swiperEle = tab.querySelector(".product-swiper");
          const swiperId = "#" + swiperEle.getAttribute("id");
          swipers[swiperId] = new Swiper(swiperId, {
            slidesPerView: 5,
            spaceBetween: 20,
            loop: false,
            navigation: {
              nextEl: `${swiperId} .swiper-button-next`,
              prevEl: `${swiperId} .swiper-button-prev`
            },
            breakpoints: {
              320: { slidesPerView: 2, spaceBetween: 10 },
              768: { slidesPerView: 2.5, spaceBetween: 15 },
              1024: { slidesPerView: 5, spaceBetween: 0 }
            }
          });
        });
        tabButtons.forEach((btn) => {
          btn.addEventListener("click", () => {
            tabButtons.forEach(b => b.classList.remove("active"));
            tabContents.forEach(c => c.classList.remove("active"));

            btn.classList.add("active");
            const targetId = btn.dataset.tab;
            const targetTab = document.getElementById(targetId);
            targetTab.classList.add("active");

            // Update swiper for active tab
            const swiperEl = targetTab.querySelector(".swiper");
            if (swiperEl && swipers[`#${swiperEl.id}`]) {
              swipers[`#${swiperEl.id}`].update();
            }
          });
        });
      })
    }
  }else{
    setTimeout(tabSwiper, 100);
  }
}
document.addEventListener("DOMContentLoaded", () => {
  tabSwiper();
  productItemJs();
  initStickyAtc();
  moveReviewSummary();
  if(window.location.search.includes('side-cart=open')){
    if (window.FitSideCart && typeof window.FitSideCart.open === 'function') {
      window.FitSideCart.open();
      clearSideCartParam();
    } else {
      const sideCartBtn = document.querySelector('#HeaderCartTrigger');
      if (sideCartBtn) sideCartBtn.click();
      clearSideCartParam();
    }
  }
});

function moveReviewSummary() {
  const title = document.querySelector('.product-single__title');
  if (!title) return;
  const block = title.closest ? title.closest('.product-block') : null;
  const meta = (block && block.parentElement) ? block.parentElement : document.querySelector('.product-single__meta');
  if (!meta) return;
  const badge = meta.querySelector('.jdgm-widget.jdgm-preview-badge, .spr-badge, [data-oke-reviews-widget]');
  if (!badge || badge.dataset.moved === 'true') return;
  title.insertAdjacentElement('afterend', badge);
  badge.dataset.moved = 'true';
}

function productItemJs() {
  const miniCart = document.querySelector('.floating-mini-cart');
  const miniImages = miniCart ? miniCart.querySelector('.mini-cart-images') : null;
  const miniCount = miniCart ? miniCart.querySelector('.mini-cart-count') : null;

  if (miniCart) {
    miniCart.addEventListener('click', function(){
      if (window.FitSideCart && typeof window.FitSideCart.open === 'function') {
        window.FitSideCart.open();
      } else {
        const sideCartBtn = document.querySelector('#HeaderCartTrigger');
        if (sideCartBtn) sideCartBtn.click();
      }
    });
  }

  async function updateMiniCart(providedCart) {
    if (!miniCart || !miniImages || !miniCount) return;
    let cart = providedCart;
    try {
      if (!cart) {
        const res = await fetch(shopifyRoute('cart.js'));
        cart = await res.json();
      }
      const count = cart.item_count;
      if (count > 0) {
        const items = cart.items.slice(0,3).reverse();
        miniImages.innerHTML = '';
        items.forEach((item) => {
          miniImages.insertAdjacentHTML('beforeend',
            `<img src="${item.image}" alt="${item.title}">`
          );
        });
        miniCount.textContent = `${count} ${count == 1 ? Shopify.locale == 'ar' ? 'المنتج' :'item' : Shopify.locale == 'ar' ? 'المنتجات' :'items'}`;
        miniCart.style.display = 'flex';
        miniCart.classList.add('visible');
      } else {
        miniCart.style.display = 'none';
      }
    } catch (err) {
      console.error('Mini cart fetch error', err);
    }
  }

  updateMiniCart();
  document.addEventListener('cart:updated', function(e){
    updateMiniCart(e.detail && e.detail.cart);
  });

  // Reuse from previous snippet: after AJAX add
  document.body.addEventListener('click', async function(e){
    const btn = e.target.closest('.product-item-atc-btn');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    const id = btn.dataset.id;

    const originalText = btn.dataset.originalText || btn.innerText;
    btn.dataset.originalText = originalText;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    if(Shopify.locale == 'ar'){
      btn.innerText = 'جارٍ الإضافة';
    }else{
      btn.innerText = 'Adding...';
    }

    try {
      const response = await fetch(shopifyRoute('cart/add.js'), {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:id, quantity:1})
      });
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
      let responseJson = await response.json();
      document.dispatchEvent(new CustomEvent('cart:build'));
      // this.dispatchEvent(
      //   new CustomEvent(EVENTS.ajaxProductAdded, {
      //     bubbles: true,
      //     detail: {
      //       product: responseJson,
      //       addToCartBtn: this.querySelector(
      //         `#ProductSubmitButton-${this.dataset.sectionId}`
      //       ),
      //     },
      //   })
      // );
      if(Shopify.locale == 'ar'){
        btn.innerText = 'تمّت الإضافة';
      }else{
        btn.innerText = 'Added!';
      }
      setTimeout(()=>{
        btn.innerText = originalText;
        btn.disabled=false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      },1200);
      if (window.FitSideCart && typeof window.FitSideCart.refresh === 'function') {
        window.FitSideCart.refresh(true);
        if (typeof window.FitSideCart.open === 'function') {
          window.FitSideCart.open();
        }
      } else {
        updateMiniCart();
      }
    } catch(err){
      console.error(err);
      btn.innerText='Error';
      setTimeout(()=>{
        btn.innerText = originalText;
        btn.disabled=false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      },1200);
    }
  });
}

function initStickyAtc() {
  const sticky = document.querySelector('[data-sticky-atc]');
  if (!sticky) return;

  const sectionId = sticky.dataset.sectionId;
  const productId = sticky.dataset.productId;
  const anchor = document.querySelector('[data-main-product-form-anchor]');
  const stickyButton = sticky.querySelector('[data-sticky-atc-submit]');
  const stickyVariant = sticky.querySelector('[data-sticky-atc-variant]');
  const stickyPrice = sticky.querySelector('[data-sticky-atc-price]');
  const productForm = sectionId ? document.querySelector(`#product-form-${sectionId}`) : null;
  const mainAddButton = productForm ? productForm.querySelector('[name=\"add\"]') : null;

  const addText = stickyButton ? stickyButton.dataset.atcText : '';
  const soldOutText = stickyButton ? stickyButton.dataset.soldOutText : '';

  function setStickyVisible(visible) {
    if (!sticky) return;
    if (visible) {
      sticky.hidden = false;
      sticky.classList.add('sticky-atc--visible');
    } else {
      sticky.classList.remove('sticky-atc--visible');
      sticky.hidden = true;
    }
  }

  function syncButtonState(variant) {
    if (!stickyButton) return;
    let isAvailable = variant ? !!variant.available : true;
    if (mainAddButton && mainAddButton.disabled) {
      isAvailable = false;
    }
    stickyButton.disabled = !isAvailable || (mainAddButton && mainAddButton.getAttribute('aria-busy') === 'true');
    stickyButton.textContent = isAvailable ? addText : soldOutText;
    const isLoading = mainAddButton && (mainAddButton.classList.contains('btn--loading') || mainAddButton.classList.contains('is-loading'));
    stickyButton.classList.toggle('is-loading', !!isLoading);
    if (isLoading) {
      stickyButton.setAttribute('aria-busy', 'true');
    } else {
      stickyButton.removeAttribute('aria-busy');
    }
  }

  function updateFromVariant(detail) {
    if (!detail || !detail.variant) return;
    const variant = detail.variant;
    if (stickyVariant) {
      stickyVariant.textContent = variant.title === 'Default Title' ? '' : variant.title;
    }
    if (stickyPrice && detail.html) {
      const priceSource = detail.html.querySelector(`block-price[data-section-id=\"${sectionId}\"] .block-price__sale .product__price, block-price[data-section-id=\"${sectionId}\"] .block-price__regular .product__price`);
      if (priceSource) {
        stickyPrice.innerHTML = priceSource.innerHTML;
      }
    }
    syncButtonState(variant);
  }

  if (anchor && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setStickyVisible(!entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(anchor);
  } else {
    setStickyVisible(true);
  }

  document.addEventListener(`variant:change:${sectionId}:${productId}`, updateFromVariant);
  syncButtonState();

  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      if (!productForm) return;
      if (mainAddButton && mainAddButton.disabled) return;
      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit();
      } else {
        productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
      syncButtonState();
    });
  }
}
document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.footer-accordion-trigger');
  triggers.forEach((btn) => {
    const target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;

    btn.addEventListener('click', function () {
      if (window.innerWidth >= 768) return; // Disable on desktop
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (expanded) target.setAttribute('hidden', '');
      else target.removeAttribute('hidden');
    });
  });
});
